import React from 'react';
import './About.css';
import familyTablet from '../assets/images/family-tablet.jpg.png';
import renewableEnergy from '../assets/images/renewable-energy.png.png';
import longTermIO from '../assets/images/long-term-i-o.png.png';
import reliabilityGrid from '../assets/images/reliability-grid.png.png';
import dashboard from '../assets/images/dashboard.png.png';

function About() {
  return (
    <section className="about" id="about">
      <h2>About Eleven Power</h2>
      <p className="about-description">
        Eleven Power is focused on building consumer-oriented renewable energy focused power distribution solutions for high-growth residential, commercial, institutional, agriculture, and industrial ecosystems. Eleven Power brings together a utility mindset, retail consumer orientation, and technology-led operating approach to serve the evolving needs of modern power consumers.
      </p>

      <div className="about-grid">
        <div className="about-card about-card-large">
          <div className="about-card-image">
            <img src={familyTablet} alt="Consumer-first" />
          </div>
          <h3>Consumer-first</h3>
          <p>Designed around clear communication, accessible service channels, and timely resolution of consumer needs.</p>
        </div>

        <div className="about-card-right">
          <div className="about-card">
            <div className="about-card-image">
              <img src={reliabilityGrid} alt="Reliability-led" />
            </div>
            <h3>Reliability-led</h3>
            <p>Focused on consistent supply, disciplined operations, and strong service accountability.</p>
          </div>

          <div className="about-card">
            <div className="about-card-image">
              <img src={dashboard} alt="Digitally enabled" />
            </div>
            <h3>Digitally enabled</h3>
            <p>Built with a modern view of billing, payments, consumer support, monitoring, and field operations.</p>
          </div>
        </div>
        <div className="about-card">
          <div className="about-card-image">
            <img src={renewableEnergy} alt=">Renewable energy-focused" />
          </div>
          <h3>Renewable energy-focused</h3>
          <p>Procuring a substantial portion of our electricity requirement from renewable energy sources instead of thermal sources.</p>
        </div>
        <div className="about-card">
          <div className="about-card-image">
            <img src={longTermIO} alt="Long-term infrastructure orientation" />
          </div>
          <h3>Long-term infrastructure orientation</h3>
          <p>A commitment to building durable, scalable, and accountable power distribution systems.</p>
        </div>
      </div>
    </section>
  );
}

export default About;
